module.exports = __webpack_public_path__ + "static/img/smile2.97528c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/smile2.png
// module id = u+of
// module chunks = 1